/**
 * Canonical store listing URLs for the Meiuca client app. Any surface that
 * points the user to the mobile app (footer, download banners) must link to
 * these — never inline store URLs elsewhere.
 */

export const APP_STORE_URL = 'https://apps.apple.com/us/app/meiuca/id6767646514'
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=br.com.meiucapp.app'
